import { createContext } from 'react';

export type RendererContextType = { viewer?: typeof viewer };
export const RendererContext = createContext<RendererContextType>({});
